import { render, staticRenderFns } from "./LabClinico.vue?vue&type=template&id=bb7271dc&scoped=true"
import script from "./LabClinico.vue?vue&type=script&lang=js"
export * from "./LabClinico.vue?vue&type=script&lang=js"
import style0 from "./LabClinico.vue?vue&type=style&index=0&id=bb7271dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7271dc",
  null
  
)

export default component.exports